import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// Pending tracking for the dashboard Approvals tile. Reads the inbox table (ScheduleNotificationsNew),
// so counts match the inbox. One call returns both the approval chains ('Level' rows) and the
// pending records ('Item' rows) for every workflow the role is part of.
export const getWorkflowTracking = async ({ userId, roleId }) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetWorkflowTracking`, {
            params: { userId, roleId },
            headers: { 'Content-Type': 'application/json' },
        });
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to get workflow tracking';
    }
};
